module.exports = __webpack_public_path__ + "static/media/whatsapp.ae8a9a2f.png";